import React from "react";
import moment from "moment";

import { client } from "../../utils/keen";
import { capitalize } from "../../util";

import WorkingIndicator from "./working-indicator.jsx";
import InlineLinkIconButton from "./inline-link-icon-button.jsx";
import KeenChart from "./charts/keen-chart.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import TicketStore from "../../stores/TicketStore";
import PersonStore from "../../stores/PersonStore";

const STATES = {
  Alabama: "AL",
  Alaska: "AK",
  AmericanSamoa: "AS",
  Arizona: "AZ",
  Arkansas: "AR",
  California: "CA",
  Colorado: "CO",
  Connecticut: "CT",
  Delaware: "DE",
  DistrictOfColumbia: "DC",
  FederatedStatesOfMicronesia: "FM",
  Florida: "FL",
  Georgia: "GA",
  Guam: "GU",
  Hawaii: "HI",
  Idaho: "ID",
  Illinois: "IL",
  Indiana: "IN",
  Iowa: "IA",
  Kansas: "KS",
  Kentucky: "KY",
  Louisiana: "LA",
  Maine: "ME",
  MarshallIslands: "MH",
  Maryland: "MD",
  Massachusetts: "MA",
  Michigan: "MI",
  Minnesota: "MN",
  Mississippi: "MS",
  Missouri: "MO",
  Montana: "MT",
  Nebraska: "NE",
  Nevada: "NV",
  NewHampshire: "NH",
  NewJersey: "NJ",
  NewMexico: "NM",
  NewYork: "NY",
  NorthCarolina: "NC",
  NorthDakota: "ND",
  NorthernMarianaIslands: "MP",
  Ohio: "OH",
  Oklahoma: "OK",
  Oregon: "OR",
  Palau: "PW",
  Pennsylvania: "PA",
  PuertoRico: "PR",
  RhodeIsland: "RI",
  SouthCarolina: "SC",
  SouthDakota: "SD",
  Tennessee: "TN",
  Texas: "TX",
  Utah: "UT",
  Vermont: "VT",
  VirginIslands: "VI",
  Virginia: "VA",
  Washington: "WA",
  WestVirginia: "WV",
  Wisconsin: "WI",
  Wyoming: "WY"
};

const STYLES = {
  entry: {
    marginTop: 5,
    lineHeight: 1.1
  },
  entryLabel: {
    color: "#848484",
    display: "block"
  },
  event_name: {
    fontWeight: "bold",
    fontSize: "1.1em"
  },
  event_time: {
    fontStyle: "italic"
  }
};

class PersonLatestInfo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fetchedPageviewPerson: null,
      soonestUpcoming: null,
      lastAttended: null
    };
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  static getStores() {
    return [TicketStore, PersonStore];
  }

  static getPropsFromStores() {
    return {
      isFetchingTickets: TicketStore.getState().isFetching
    };
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    // Keen integration disabled
    // if (this.state.fetchedPageviewPerson !== newProps.personId) {
    //   this.setState({ fetchedPageviewPerson: newProps.personId });
    //   client.query('extraction', {
    //     event_collection: 'pageviews',
    //     filters: [{'operator':'eq','property_name':'person','property_value':newProps.personId}],
    //     timeframe: 'this_30_days',
    //     latest: 2
    //   }).then(res => {
    //     this.setState({ lastPageviewData: res.result });
    //   });
    // }

    let now = new Date().toISOString(),
      tickets = TicketStore.getTicketsForPerson(newProps.personId),
      soonestUpcoming =
        tickets.some(t => t.event.start_time > now) &&
        tickets
          .filter(t => t.event.start_time > now)
          .reduce((a, b) => (a.event.start_time < b.event.start_time ? a : b)),
      lastAttended =
        tickets.some(t => t.used_at) &&
        tickets
          .filter(t => t.used_at)
          .reduce((a, b) => (a.used_at > b.used_at ? a : b));

    this.setState({
      soonestUpcoming,
      lastAttended
    });
  }

  render() {
    let { soonestUpcoming, lastAttended } = this.state,
      { isFetchingTickets, personId, style } = this.props,
      person = PersonStore.getPersonById(personId);

    if (!person || isFetchingTickets) {
      return (
        <div style={style}>
          <WorkingIndicator centered />
        </div>
      );
    }

    return (
      <div style={style}>
        <div style={STYLES.entry}>
          <span style={STYLES.entryLabel}>Last seen online</span>
          <KeenChart
            query="extraction"
            options={{
              event_collection: "pageviews",
              filters: [
                {
                  operator: "eq",
                  property_name: "person",
                  property_value: this.props.personId
                }
              ],
              timeframe: "this_30_days",
              latest: 1
            }}
          >
            {({ data, message }) => {
              if (data) {
                if (data.result.length) {
                  let result = data.result[0],
                    lastSeen = moment(result.keen.timestamp);

                  return (
                    <div>
                      <div>
                        <span title={lastSeen.format("LLLL")}>
                          {capitalize(lastSeen.fromNow())}
                        </span>{" "}
                        near{" "}
                        <a
                          href={`https://www.google.com/maps/?q=${result.geo.info.coordinates[1]},${result.geo.info.coordinates[0]}`}
                          target="_blank"
                        >
                          {result.geo.info.city || result.geo.info.country}
                          {result.geo.info.province &&
                            `, ${STATES[result.geo.info.province] ||
                              result.geo.info.province}`}
                        </a>
                      </div>
                      <div>
                        Viewed "
                        <a href={result.page.url} target="_blank">
                          {result.page.title.split("|")[0].trim()}
                        </a>
                        " on {result.tech.info.os.family}
                      </div>
                    </div>
                  );
                } else {
                  return <div>Not seen in the last 180 days</div>;
                }
              } else {
                return <div>Loading...</div>;
              }
            }}
          </KeenChart>
        </div>
        <div style={STYLES.entry}>
          <span style={STYLES.entryLabel}>Next upcoming event</span>
          {soonestUpcoming ? (
            <span>
              <span style={STYLES.event_name}>
                {soonestUpcoming.event.name}
              </span>
              &nbsp;
              <span style={STYLES.event_time}>
                {moment(soonestUpcoming.event.start_time).fromNow()}
              </span>
              <InlineLinkIconButton
                tooltip="View event"
                onTouchTap={() =>
                  this.context.router.push(
                    `/event_buckets/${soonestUpcoming.event_bucket}/events/${soonestUpcoming.event.id}`
                  )
                }
              />
            </span>
          ) : (
            <span style={STYLES.event_time}>No upcoming events</span>
          )}
        </div>
        <div style={STYLES.entry}>
          <span style={STYLES.entryLabel}>Last event attended</span>
          {lastAttended ? (
            <span>
              <span style={STYLES.event_name}>{lastAttended.event.name}</span>
              &nbsp;
              <span style={STYLES.event_time}>
                {moment(lastAttended.event.start_time).fromNow()}
              </span>
              <InlineLinkIconButton
                tooltip="View event"
                onTouchTap={() =>
                  this.context.router.push(
                    `/event_buckets/${lastAttended.event_bucket}/events/${lastAttended.event.id}`
                  )
                }
              />
            </span>
          ) : (
            <span style={STYLES.event_time}>No events attended yet</span>
          )}
        </div>
      </div>
    );
  }
}

export default connectToStores(PersonLatestInfo);



// WEBPACK FOOTER //
// ./src/app/components/partials/person-latest-info.jsx